import { createSlice } from '@reduxjs/toolkit';
import { NO_CURRENT_ENTITY } from 'consts/store';
import { DATA_UNDEFINED, NO_ERRORS } from 'consts/xhr';
import {
  pendingActionHandler,
  readyActionHandler,
  rejectActionHandler,
} from 'helpers/sliceHelpers';
import {
  fetchById as fetchProposalById,
  fetchAllProposals,
  setCurrentProposal as setCurrent,
  fetchAllProposalsForCurrentCampaign,
  fetchProposalsOfBasket,
  create,
  accept,
  rectify,
  submit,
  cancel,
  suspend,
  resume,
  updateProposalChatViewTS,
  updateProposalViewTS,
  updateProposalMaterialViewTS,
  acceptCounterOffer,
  rejectCounterOffer,
  watchProposal,
} from './proposals.actions';
import adapter from './proposals.adapter';
import { REDUCER_KEY } from './proposals.consts';

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    ...adapter.getInitialState(),
    status: DATA_UNDEFINED,
    errors: NO_ERRORS,
    current: NO_CURRENT_ENTITY,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAllProposals.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(fetchAllProposalsForCurrentCampaign.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(fetchProposalById.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(fetchProposalsOfBasket.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(setCurrent.pending, (state, action) => {
        state.current = action.meta.arg;
      })
      .addCase(create.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(accept.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(rectify.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(submit.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(cancel.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(suspend.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(resume.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(watchProposal.fulfilled, (state, action) => {
        adapter.updateOne(state, action.payload);
      })
      .addCase(setCurrent.fulfilled, (state, action) => {
        if (action.payload) {
          state.current = action.payload.id;
          adapter.upsertOne(state, action.payload);
        } else {
          state.current = NO_CURRENT_ENTITY;
        }
      })
      .addCase(updateProposalChatViewTS.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(updateProposalViewTS.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(updateProposalMaterialViewTS.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(acceptCounterOffer.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(rejectCounterOffer.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(REDUCER_KEY + '/removeAll', state => adapter.removeAll(state))
      .addMatcher(
        ({ type }) =>
          type.startsWith(REDUCER_KEY) && type.endsWith('fulfilled'),
        readyActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('pending'),
        pendingActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('rejected'),
        rejectActionHandler,
      );
  },
});

export const { reducer } = slice;
